import React from "react";

import { InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import { OnboardingSelectorOptions } from "libLegacy/api/onboarding/onboardingModels";

export const CustomSelect = ({
  id,
  value,
  onChange,
  label,
  options,
}: SelectProps) => {
  return (
    <FormControl>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        required
        fullWidth
        id={id}
        value={value || ""}
        onChange={onChange}
        label={label}
        style={{ fontFamily: "Montserrat, sans-serif" }}
      >
        {options?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

type SelectProps = {
  id?: string;
  value?: number;
  onChange: any; //TODO set the right type
  label?: string;
  options: OnboardingSelectorOptions[];
};
